import { FC, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import TopBarStore from '../../app/stores/top-bar-store';
import { useAppOwners } from '../../application-owners/api/applications-owners-api';
import Panel from '../../elements/Panel/Panel';
import {
  loadArtifacts,
  loadArtifactsFilters,
  loadArtifactsTopFilters,
  onChangeTopFilter,
} from '../actions/artifacts-actions';
import ArtifactsTopFilters from '../components/ArtifactsTopFilters';
import ArtifactsStore from '../stores/artifacts-store';
import { ArtifactTopFiltersTypes } from '../types/artifacts-type';

const ArtifactsTopFiltersContainers: FC<React.PropsWithChildren> = () => {
  const { dateRange } = useSnapshot(TopBarStore);
  const { artifacts } = useSnapshot(ArtifactsStore);
  const { displaySelectedAppOwners } = useAppOwners();

  useEffect(() => {
    loadArtifactsTopFilters();
    loadArtifacts();
    loadArtifactsFilters();
  }, [dateRange, displaySelectedAppOwners]);

  const {
    artifactsTopFiltersList,
    total,
    topFiltersArtifactsBy: appliedFilters,
  } = useSnapshot(ArtifactsStore);

  const onInventoryFilterClick = (filterType: ArtifactTopFiltersTypes) => {
    onChangeTopFilter(filterType);
  };

  if (artifacts && artifacts.length > 0) {
    return (
      <Panel flexShrink={0} mb={2}>
        <ArtifactsTopFilters
          artifactTopFiilters={artifactsTopFiltersList}
          totalArtifacts={total}
          onInventoryFilterClick={onInventoryFilterClick}
          appliedFilters={appliedFilters}
        />
      </Panel>
    );
  }
  return null;
};

export default ArtifactsTopFiltersContainers;
